import type { AdditionalDocFormData } from '../../../graphql';
import {
  type FormController,
  FormModificationMode,
} from '../../../../../utils';

export type AdditionalDocumentControl = Record<
  keyof AdditionalDocFormData,
  boolean
> & {
  enableSave: boolean;
  enableDelete: boolean;
  enableSaveCondition: boolean;
};

export type AdditionalDocumentFieldPermissions = Omit<
  AdditionalDocumentControl,
  '_id'
>;

// Only records with "I will update result at xxx" can be updated.
export const editAdditionalDocumentPermission = (
  control: FormController,
): AdditionalDocumentFieldPermissions => {
  const { formModificationMode } = control;

  const disableAdditionalDocumentFieldPermissions: AdditionalDocumentFieldPermissions =
    {
      documentType: false,
      supportingDocuments: false,
      enableSave: false,
      enableSaveCondition: false,
      enableDelete: false,
    };

  const enableAdditionalDocumentFieldPermissions: AdditionalDocumentFieldPermissions =
    {
      ...Object.assign(
        {},
        ...Object.keys(disableAdditionalDocumentFieldPermissions).map(key => ({
          [key]: true,
        })),
      ),
      enableSaveCondition:
        control.formModificationMode === FormModificationMode.CONDITION_MEET,
    };

  const modifyAdditionalDocumentFieldPermissions: AdditionalDocumentFieldPermissions =
    {
      ...enableAdditionalDocumentFieldPermissions,
      enableDelete: false,
    };

  const AdditionalDocumentPermission: Record<
    FormModificationMode,
    AdditionalDocumentFieldPermissions
  > = {
    [FormModificationMode.ENABLE]: enableAdditionalDocumentFieldPermissions,
    [FormModificationMode.DISABLE]: disableAdditionalDocumentFieldPermissions,
    [FormModificationMode.MODIFIED_ONLY]:
      modifyAdditionalDocumentFieldPermissions,
    [FormModificationMode.CONDITION_MEET]:
      enableAdditionalDocumentFieldPermissions,
  };

  return AdditionalDocumentPermission[formModificationMode];
};
